;(function () {
	function getCollectionUrl(baseUrl, sortType) {
		const sortTypes = {
			alphabetical: 'title-ascending',
			alphabetical_reversed: 'title-descending',
			products_low: 'price-ascending',
			products_high: 'price-descending',
			date: 'created-ascending',
			date_reversed: 'created-descending',
			featured: 'manual',
			best_selling: 'best-selling',
		}

		const sortBy = sortTypes[sortType] || sortTypes.alphabetical
		return `${baseUrl}?sort_by=${sortBy}`
	}

	async function handleResponse(response, section, limitProducts) {
		const html = await response.text()
		const parser = new DOMParser()
		const doc = parser.parseFromString(html, 'text/html')

		const targetGrid = section.querySelector('#products-grid')
		const sourceGrid = doc?.getElementById('product-grid')
		if (!targetGrid || !sourceGrid || !sourceGrid?.children) return

		const sourceItems = Array.from(sourceGrid.children)
		let limit =
			sourceItems.length > limitProducts ? limitProducts : sourceItems.length

		const slicedItems = sourceItems.slice(0, limit)
		targetGrid.innerHTML = ''
		slicedItems.forEach((item) => {
			item.classList.remove('collection-product-card--extended')
			targetGrid.appendChild(item)
		})
	}

	const initSection = async (section) => {
		if (!section || !section.classList.contains('products-grid-section')) return

		const box = section.querySelector('.products-grid')
		if (!box) return

		const isDynamicLoad = box.dataset.isDynamicLoad === 'true'
		const baseUrl = box.dataset.baseUrl
		const sortType = box.dataset.sortType
		const limitProducts = Number(box.dataset.limitProducts)

		if (isDynamicLoad && baseUrl && baseUrl !== 'none' && sortType) {
			const url = getCollectionUrl(baseUrl, sortType)

			box.classList.add('products-grid--loading')
			try {
				const response = await fetch(url)
				await handleResponse(response, section, limitProducts)
				try {
					colorSwatches()
				} catch (err) {}
			} catch (error) {
				console.error(
					'Products grid: Error when fetching the collection page:',
					error
				)
			} finally {
				box.classList.remove('products-grid--loading')
			}
		} else {
			box.classList.remove('products-grid--loading')
		}
	}

	initSection(document.currentScript.parentElement)

	// Timer functionality for seasonal sale countdown
	function initTimer(section) {
		const timerContainer = section.querySelector('.timer__container')
		if (!timerContainer) return

		const daysEl = timerContainer.querySelector('.days__number')
		const hoursEl = timerContainer.querySelector('.hours__number')
		const minutesEl = timerContainer.querySelector('.minutes__number')
		const secondsEl = timerContainer.querySelector('.seconds__number')

		if (!hoursEl || !minutesEl || !secondsEl) return

		// Get end date from data attribute or default to 24 hours from now
		const timerEndDate = timerContainer.dataset.timerEnd
		let endDate
		
		if (timerEndDate && timerEndDate.trim() !== '') {
			// Parse the date string from the schema setting
			endDate = new Date(timerEndDate)
			// If the date is invalid, fall back to 24 hours from now
			if (isNaN(endDate.getTime())) {
				endDate = new Date()
				endDate.setHours(endDate.getHours() + 24)
			}
		} else {
			// Default to 24 hours from now
			endDate = new Date()
			endDate.setHours(endDate.getHours() + 24)
		}
		
		function updateTimer() {
			const now = new Date().getTime()
			const distance = endDate.getTime() - now

			if (distance < 0) {
				// Timer expired - hide the timer container
				timerContainer.style.display = 'none'
				// Clear the interval to stop the timer
				clearInterval(timerContainer.timerInterval)
				timerContainer.timerInterval = null
				return
			}

			const days = Math.floor(distance / (1000 * 60 * 60 * 24))
			const hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
			)
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
			const seconds = Math.floor((distance % (1000 * 60)) / 1000)

			// Format with leading zeros and limit hours to 99
			if (daysEl) {
				daysEl.textContent = days.toString().padStart(2, '0')
			}
			hoursEl.textContent = hours.toString().padStart(2, '0')
			minutesEl.textContent = minutes.toString().padStart(2, '0')
			secondsEl.textContent = seconds.toString().padStart(2, '0')
		}

		// Update immediately and then every second
		updateTimer()
		const timerInterval = setInterval(updateTimer, 1000)

		// Store interval reference for cleanup
		timerContainer.timerInterval = timerInterval
	}

	function cleanupTimer(section) {
		const timerContainer = section.querySelector('.timer__container')
		if (timerContainer && timerContainer.timerInterval) {
			clearInterval(timerContainer.timerInterval)
			timerContainer.timerInterval = null
		}
	}

	// Initialize timer when section loads
	const sectionElement = document.currentScript.parentElement
	initSection(sectionElement)
	initTimer(sectionElement)

	document.addEventListener('shopify:section:load', function (event) {
		initSection(event.target)
		initTimer(event.target)
	})

	document.addEventListener('shopify:section:unload', function (event) {
		cleanupTimer(event.target)
	})
})()
